export default __webpack_public_path__ + "static/media/AvenirNext-UltraLight.1c3101b8.woff";